// removed by extract-text-webpack-plugin
module.exports = {"pageBreak":"_21cUG9bi2XlLM9tCin7gqV"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/VEditor/VEditor.scss
// module id = 1101
// module chunks = 0